import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment';
//import BindCardAuthFetch from './BindCardAuthFetch';
//import BindCardAuthUpdateMutation from './BindCardAuthUpdateMutation';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Button, Grid, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import ServerError from '../ui/ServerError';
import LoadingSpinner from '../ui/LoadingSpinner';
import SearchField from '../ui/SearchField';
import EnvironmentDefs from '../../EnvironmentDefs';
import AppBindStyles from '../../AppBindStyles';
import { format } from 'date-fns';

const envDefs = new EnvironmentDefs();
const abEnvironment = new AbEnvironment();
const BindCardsQuery = graphql`
query BindCardsQuery($appname: String!, $provisioning: String!, $using: String!, $first: Int) {
  getbindcardbyappandusers(appname: $appname, provisioningaccountname: $provisioning, 
                           usingaccountname: $using, first: $first) {
    totalCount
    nodes {
      bcId
      bcLast4
      bcStatus
      customerAppId
      customerAppStatus
      appId
      appName
      provisioningAccountId
      provisioningAccountName
      usingAccountId
      usingAccountName
    }
  }
}
`;

const styleSheet = theme => ({
    root: {
      flexGrow: 1,
      marginTop: 10,
    },
    tabroot: {
      flexGrow: 1,
      margin: 10,
      width: '100%',
    },
    flex: {
      flex: 1,
    },
    paper1: {
      padding: 16,
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
    paper2: {
      padding: 12,
      textAlign: 'left',
      color: theme.palette.text.secondary,
    },
    container: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    formControl: {
      margin: 'theme.spacing(1)',
    },
    textField: {
      margin: 'theme.spacing(1)',
      marginBottom: 6,
    },
    textFieldAddress: {
      margin: 'theme.spacing(1)',
    },
    titleContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    statusdiv: {
      display: 'flex',
      alignItems: 'center',
      direction: 'row',
      justify: 'center',
    },
    statusicon: {
      width: 52,
      height: 52,
      color: 'green',
    },
    erroricon: {
      width: 52,
      height: 52,
      color: 'red',
    },
});

class BindCards extends Component {
  constructor(props) {
    super(props);

    let s1 = localStorage.getItem('bindcardsS1');
    let s2 = localStorage.getItem('bindcardsS2');
    let s3 = localStorage.getItem('bindcardsS3');

    this.state = {
      appname:      s1 == null ? '': s1,
      provisioning: s2 == null ? '': s2,
      using:        s3 == null ? '': s3,
      simDate:      new Date(),
      simStat:      'Ready'
    }
  }

    goTo(route) {
      localStorage.setItem('bindcardsS1', this.state.appname);
      localStorage.setItem('bindcardsS2', this.state.provisioning);
      localStorage.setItem('bindcardsS3', this.state.using);
      this.props.history.push(`/${route}`);
    }
    
    handleChange = name => event => {
      this.setState({
        [name]: event.target.value,
      });
    };

    promisedSetState = (newState) => {
      return new Promise((resolve) => {
          this.setState(newState, () => {
              resolve();
          })
      })
    }

    simulateTransactions() {
      const { callPartnerApi } = this.props.auth;

      let sdate = format(new Date(this.state.simDate), 'yyyy-MM-dd');

      // Skip call means that we're just auditing the transaction
      let payload = {
        operation: "initiateSimulatedSubscriptionTransactions",
        params: {
          simDate: sdate,
          skipCall: 0
        }
      };
      
      // alert('The date is ' + sdate);
      this.promisedSetState({simStat: "Simulating..."})
      .then(() => {
        // Call backend to auth and clear, get returned transaction value (via server API)
        return callPartnerApi('appbind/generic', 'POST', payload);
      }).then(response => {
        return response.json();
      }).then(theResponse => {
        if (theResponse.status !== 0) {
          let emsg = "Error in simulation: " + theResponse.message;        
          this.setState({simStat: emsg});
          return;
        }

        let aMsg = "Simulation: " + theResponse.transactionCount + " transactions succeeded, " + theResponse.authFailCount + " auths failed, " + theResponse.clearFailCount + " clears failed.";
        this.setState({simStat: aMsg});
      }).catch(error => {
        let errMesg = "Error in simulation: " + error;
        this.setState({simStat: errMesg});
      });
    }

    render() {
        const { isAuthenticatedAppBind, logError } = this.props.auth;
        const classes = this.props.classes;
    
        if (isAuthenticatedAppBind()) {
          let theEnv = envDefs.getEnv();
          return (
            <Grid container spacing={2} direction="row">
              {(theEnv === 'poc' || theEnv === 'devpoc') &&
              <Grid item xs={12}>
                <Grid container spacing={2} direction="row" alignItems="center">
                  <Grid item style={AppBindStyles.datePickerField}>
                    <DatePicker 
                      disableFuture
                      label="Date for simulation"
                      value={this.state.simDate}
                      onChange={(newValue) => {
                        this.setState({simDate: newValue});
                      }}
                      renderInput={(params) => (
                        <TextField 
                          {...params}
                          sx={{
                            svg: {paddingRight: '2px'}
                          }}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item>
                    <Button color="primary" variant="outlined" onClick={() => { this.simulateTransactions(); }}>Simulate transactions</Button>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography>{this.state.simStat}</Typography>
                  </Grid>
                </Grid>
              </Grid>}
              <Grid item xs={12}>
                <Grid container spacing={1} direction="row">
                  <Grid item>
                    <SearchField
                      id="app-name"
                      label="Search by App Name"
                      value={this.state.appname}
                      onChange={this.handleChange('appname')}
                    />
                  </Grid>
                  <Grid item>
                    <SearchField
                      id="provisioning-name"
                      label="Search by Provisioning Account"
                      value={this.state.provisioning}
                      onChange={this.handleChange('provisioning')}
                    />
                  </Grid>
                  <Grid item>
                    <SearchField
                      id="using-name"
                      label="Search by Using Account"
                      value={this.state.using}
                      onChange={this.handleChange('using')}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <QueryRenderer
                  environment={abEnvironment.getEnvironment()}
                  query={BindCardsQuery}
                  variables={{appname: this.state.appname, provisioning: this.state.provisioning, using: this.state.using, first: 20}}
                  render={({error, props})=> {
                    if (error) {
                      logError(error.message);
                      return (
                        <ServerError/>
                      );
                    } else if (props) {
                      let displayCount = props.getbindcardbyappandusers.nodes.length;
                      let totalCount = props.getbindcardbyappandusers.totalCount;

                      let theMessage = "No matching bindcards.";
                      if (totalCount > displayCount) {
                        theMessage = "Showing " + displayCount + " of " + totalCount + 
                        " matching bindcards.  Please use search terms to refine your search.";
                      } else if (displayCount > 1) {
                        theMessage = "Found " + displayCount + " matching bindcards.";
                      } else if (displayCount === 1) {
                        theMessage = "Found 1 matching bindcard.";
                      }

                      return(
                        <div className={classes.root}>
                          <Typography>{theMessage}</Typography>
                          <Table>
                            <TableHead>
                              <TableRow>
                                <TableCell>Id</TableCell>
                                <TableCell>Last4</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell>App</TableCell>
                                <TableCell>Reseller</TableCell>
                                <TableCell>Customer</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {props.getbindcardbyappandusers.nodes.map(n => {
                                let bcs = 'bindcardsummary?bcId=' + n.bcId;

                                let theStatus = 'Active';
                                if (n.bcStatus === 1)
                                  theStatus = 'Suspended';
                                else if (n.bcStatus === 2)
                                  theStatus = 'Terminated';

                                return (
                                  <TableRow key={n.bcId} onClick={this.goTo.bind(this, bcs)}>
                                    <TableCell>{n.bcId}</TableCell>
                                    <TableCell>{n.bcLast4}</TableCell>
                                    <TableCell>{theStatus}</TableCell>
                                    <TableCell>{n.appName}</TableCell>
                                    <TableCell>{n.provisioningAccountName}</TableCell>
                                    <TableCell>{n.usingAccountName}</TableCell>
                                  </TableRow>
                                );
                              })}
                            </TableBody>
                          </Table>
                        </div>
                      );
                    }
                    return <div><LoadingSpinner/></div>
                  }}
                />
              </Grid>
            </Grid>
          );              
        } else {
          return (
            <Redirect to='/home' />
          );
        }    
    }
}

BindCards.propTypes = {
  classes: PropTypes.object.isRequired,
};
      
export default withStyles(styleSheet)(BindCards);
